import React, { Component } from 'react';
import RouteElementContentTitle from './RouteElementContentTitle';
import RouteElementContentSubTitle from './RouteElementContentSubTitle';

class RouteElementContent extends Component {
	render() {
		const { title, summary } = this.props;
		return <div className = 'route_element_content'>
			<RouteElementContentTitle 
				display = { title }
			/>
			<RouteElementContentSubTitle 
				display = { summary }
			/>
		</div>;
	}
}

export default RouteElementContent;


// WEBPACK FOOTER //
// ./src/components/home/RouteElementContent.jsx